import { Injectable } from '@angular/core';
import { FeedbackService } from '@careapp-group/ng-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import * as actions from '../actions';
import * as selectors from '../reducers/index';
import { Feedback } from './feedback.actions';

@Injectable()
export class FeedbackEffects {
  listFeedback$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Feedback.RequestRetrieveAllAction),
      withLatestFrom(
        this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)),
        this.store.select(selectors.statistics.getFilters),
        this.store.select(selectors.getSelectedId(selectors.TENANTS))
      ),
      switchMap(([action, orgId, filters, tenantId]) => {
        return this.api
          .listFeedback({
            organisationId: orgId,
            tenantId,
            limit: null,
            skip: null,
            endDate: filters?.endDate?.toISOString(),
            startDate: filters?.startDate?.toISOString(),
          })
          .pipe(
            map((response: Array<any>) =>
              Feedback.ResponseSuccessRetrieveAllAction({ payload: response })
            ),
            catchError((err) => of(Feedback.ResponseFailRetrieveAllAction(err)))
          );
      })
    )
  );

  fetchRelatedMembers$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(Feedback.ResponseSuccessRetrieveAllAction),
        tap((action) => {
          action.payload.map((stat) => {
            this.store.dispatch(actions.Members.RequestByIdAction({ id: stat.memberId }));
          });
        })
      ),
    { dispatch: false }
  );

  submitFeedback$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Feedback.RequestCreateAction),
      withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
      switchMap(([action, orgId]) => {
        const { type, ...payload } = action;
        return this.api
          .createFeedback({
            createFeedbackRequestDto: { ...action.payload, organisationId: orgId },
          })
          .pipe(
            map((response) => Feedback.ResponseSuccessCreateAction({ payload: response })),
            catchError((err) => of(Feedback.ResponseFailCreateAction({ error: err })))
          );
      })
    )
  );

  constructor(
    private actions$: Actions<any>,
    private store: Store<any>,
    private api: FeedbackService
  ) {}
}
